import type { FC, FormEvent } from 'react';
import ReactDOM from 'react-dom';
import { Button } from '../../components/Button';
import type { CreateFormData } from './hooks/useProxyProfiles';
import styles from './ProxyConfig.module.css';

interface CreateProfileModalProps {
  formData: CreateFormData;
  onChange: (data: CreateFormData) => void;
  onSubmit: (e: FormEvent) => void;
  onClose: () => void;
}

export const CreateProfileModal: FC<CreateProfileModalProps> = ({ formData, onChange, onSubmit, onClose }) => {
  return ReactDOM.createPortal(
    <div
      className={styles.modalOverlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Add New Profile</h3>
        </div>

        <form onSubmit={onSubmit} className={styles.modalBody}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Profile Name *</label>
            <input
              className={styles.input}
              value={formData.name}
              onChange={(e) => onChange({ ...formData, name: e.target.value })}
              placeholder="My Authentication Profile"
              required
              autoFocus
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Description</label>
            <textarea
              className={styles.textareaSmall}
              value={formData.description}
              onChange={(e) => onChange({ ...formData, description: e.target.value })}
              placeholder="Profile description"
            />
          </div>

          <div className={styles.modalFooter}>
            <Button type="submit" variant="success">
              Create Profile
            </Button>
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
};
